/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentMethodConnectionActivityStateDto = {
    WAS_ACTIVE_IN_THE_PAST: 'WAS_ACTIVE_IN_THE_PAST',
    IS_ACTIVE_NOW: 'IS_ACTIVE_NOW',
    WILL_BE_ACTIVE_IN_THE_FUTURE: 'WILL_BE_ACTIVE_IN_THE_FUTURE'
} as const;
export type PaymentMethodConnectionActivityStateDto = typeof PaymentMethodConnectionActivityStateDto[keyof typeof PaymentMethodConnectionActivityStateDto];


export function instanceOfPaymentMethodConnectionActivityStateDto(value: any): boolean {
    for (const key in PaymentMethodConnectionActivityStateDto) {
        if (Object.prototype.hasOwnProperty.call(PaymentMethodConnectionActivityStateDto, key)) {
            if (PaymentMethodConnectionActivityStateDto[key as keyof typeof PaymentMethodConnectionActivityStateDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentMethodConnectionActivityStateDtoFromJSON(json: any): PaymentMethodConnectionActivityStateDto {
    return PaymentMethodConnectionActivityStateDtoFromJSONTyped(json, false);
}

export function PaymentMethodConnectionActivityStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodConnectionActivityStateDto {
    return json as PaymentMethodConnectionActivityStateDto;
}

export function PaymentMethodConnectionActivityStateDtoToJSON(value?: PaymentMethodConnectionActivityStateDto | null): any {
    return value as any;
}

export function PaymentMethodConnectionActivityStateDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentMethodConnectionActivityStateDto {
    return value as PaymentMethodConnectionActivityStateDto;
}

